<template>
  <div>
    <div style="display:none">
      <input type="file" id="f1" @change="fileImg" />
    </div>
    <div style="background-color: white; padding: 15px;">
      <div style="padding-bottom: 15px; border-bottom: 1px solid #e7e7e7">
        <span style="font-size: 13px; color:#97a8be">首页 / 抽奖管理 / 奖品列表 / 保存</span>
      </div>
      <div style="padding-top: 15px;">
        <table width="100%">
          <tr>
            <td class="leftTd">
              奖品名称
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="name" class="boxText"/>

            </td>
          </tr>
          <tr>
            <td class="leftTd">
              中奖概率
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="rate" class="boxText"/> %

            </td>
          </tr>
          <tr>
            <td class="leftTd">
              奖品图片
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <img :src="showImg" style="width: 100px;cursor:pointer;" onclick="f1.click()" />
              （用于APP显示）
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              奖品类型
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <select v-model="type" class="boxText">
                <option value="0">实物</option>
                <option value="1">现金红包</option>
              </select>
            </td>
          </tr>
          <tr v-if="type=='1'">
            <td class="leftTd">
              红包金额
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="note" class="boxText"/>
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              状态
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <select v-model="state" class="boxText">
                <option value="0">启用</option>
                <option value="-1">禁用</option>
              </select>
            </td>
          </tr>
        </table>
      </div>

      <div style="padding-top: 15px; padding-bottom: 25px; padding-left: 150px">
        <input @click="addAdmin" type="button" style="cursor: pointer; padding: 10px 25px; border-radius: 3px; background-color: #1890ff; border: 1px solid #1890ff; color: white" value="保存" />
        <input @click="goback" type="button" style="cursor: pointer; padding: 10px 25px; border-radius: 3px; background-color: #ffffff; border: 1px solid #dbdbdb; margin-left: 15px; color: #606266" value="返回" />
      </div>
    </div>

  </div>
</template>

<script>

import {closeLoading, DO_NET_URL, FILE_URL, loading, toask} from "@/config/config";
import {axiosGet, axiosPost, axiosPostJson} from "@/main";
import axios from "axios";
import router from "@/router";

export default {
  name: "UpdateAward",
  data(){
    return{
      id:"",
      name:"",
      rate:"",
      type:"0",
      note:"",
      state:"",
      imgUrl:"",
      showImg:"",
    }
  },
  mounted(){
    let that=this
    if(localStorage.getItem("iwa_token")==null||localStorage.getItem("iwa_token")==""){
      setTimeout(function (){
        that.$router.replace('index')
      },600);
    }
    let json=JSON.parse(localStorage.getItem("UPDATEOBJ"))
    console.log(json)
    this.id=json.awardId.toString()
    this.name=json.awardName.toString()
    this.rate=json.awardRate.toString()
    this.type=json.awardType.toString()
    this.note=json.awardNote.toString()
    this.state=json.awardState.toString()
    this.imgUrl=json.awardIcon.toString()
    if(this.imgUrl==""){
      this.showImg=require('@/assets/fileImg.png')
    }else{
      this.showImg=FILE_URL+this.imgUrl
    }
  },
  methods: {
    fileImg(){
      let that=this
      var formData=new FormData()
      formData.append("files",document.querySelector("#f1").files[0])
      axios.post(DO_NET_URL+"other/UploadImg", formData, {
        headers: {
          token: localStorage.getItem("iwa_token"),
          'Content-Type': "multipart/form-data",
          'timestamp': new Date().getTime(),
          'accreditToken': localStorage.getItem("accreditToken"),
        }
      }).then(response => {
        if (response.data.data == "请登录！") {
          setTimeout(function () {
            router.replace('index')
          }, 600);
        } else {

          console.log(response.data);
          var v=response.data
          if(v.code==200){
            toask("上传成功！",6)
            that.showImg=FILE_URL+v.data.img
            that.imgUrl=v.data.img
          }else{
            toask(v.data,6)
          }
        }

      }).catch(error => {
        // 处理错误情况
        console.error(error);
      });
    },
    addAdmin(){
      let that=this
      if(this.name==""){
        toask("请输入奖品名称！",6)
        return
      }
      if(this.rate==""){
        toask("请输入中奖概率（%）！",6)
        return;
      }
      if(this.type=="1"&&this.note==""){
        toask("请输入红包金额！",6)
        return;
      }

      loading("请求中")
      let param="id="+this.id+"&name="+this.name+"&rate="+this.rate+"&type="+this.type+"&note="+this.note+"&state="+this.state+"&img="+this.imgUrl
      axiosPost(DO_NET_URL+"choujiang/EditAward?"+param,"",function (res){
        closeLoading()
        if(res.code==200){
          toask("保存成功",6)
          setTimeout(function (){
            that.$emit("send",'awardList')
          },600)
        }else{
          toask(res.data,6)
        }
      })
    },
    goback(){
      this.$emit("send",'awardList')
    },

  }
}
</script>

<style scoped>
.boxText{-webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: 12px;
  height: 40px;
  /*line-height: 40px;*/
  outline: none;
  padding: 0 15px;
  -webkit-transition: border-color .2s cubic-bezier(.645,.045,.355,1);
  transition: border-color .2s cubic-bezier(.645,.045,.355,1);
  width: 50%;}
.leftTd{text-align: right;
  vertical-align: middle;
  font-size: 12px;
  color: #606266;
  line-height: 40px;
  padding: 15px 12px 0 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;font-weight: 700; width: 120px}
.addBtn{color: #1890ff;background: #e8f4ff; border: 1px solid #1890ff; cursor: pointer; float: left; font-size: 12px;padding: 7px 15px;border-radius: 3px;}
.th{border-bottom:1px solid #dfe6ec; text-align: left; padding:0 10px;word-break: break-word;background-color: #f8f8f9;color: #515a6e;height: 40px;font-size: 12px;}
.td{border-bottom:1px solid #dfe6ec;padding:0 10px; word-break:break-word;background-color: #ffffff;color: #606266;height: 40px;font-size: 12px;}
</style>